
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]",
      function () {
        return require("private-next-pages/[locale]/index.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]"])
      });
    }
  